import { merge } from 'lodash-es';
import { ImResponse, resolve, storeHomeV2Client } from '..';

export const listDepartmentAndRoles = () => {
  return resolve(
    storeHomeV2Client.get<
      ImResponse<{
        departmentAndRoleOfItList: StoreHomeV2.DepartmentWithRoles[];
      }>
    >('/admin/department_and_roles'),
  );
};

interface ListDepartmentsParams {
  type?: StoreHomeV2.Department['type'];
}

export const listDepartments = (params?: ListDepartmentsParams) => {
  return storeHomeV2Client.get<
    ImResponse<{
      departments: StoreHomeV2.Department[];
    }>
  >('/admin/departments', {
    params,
  });
};

/**
 * 补正后端返回时PlatformScopes 某些默认定义缺失的部分（主要为数组）
 * @param departmentDetail
 * @returns
 */
const departmentPlatformStoreScopesDeamon = <T extends StoreHomeV2.DepartmentDetail>(
  departmentDetail: T,
): T => {
  const res = {
    ...departmentDetail,
    platformStoreScopes: (departmentDetail.platformStoreScopes || []).map((p) => {
      return {
        ...p,
        regionStoreScopes:
          p?.regionStoreScopes?.map?.((r) => {
            return merge({ storeIds: [] }, r);
          }) || [],
      };
    }),
  };
  return res;
};
export const getDepartmentDetail = (id?: StoreHomeV2.Department['id'], signal?: AbortSignal) => {
  return storeHomeV2Client
    .get<ImResponse<StoreHomeV2.DepartmentDetail>>(`/admin/departments/${id}`, { signal })
    .then((r) => departmentPlatformStoreScopesDeamon(r.data.data));
};

export interface CreateDepartmentResponse extends StoreHomeV2.Department {
  id: StoreHomeV2.Department['id'];
  name: string;
  platformStoreScopes: General.StoreScope[];
}
export interface CreateDepartmentRequest {
  name: string;
  platformStoreScopes: General.StoreScope[];
}
/**
 * 创建部门
 * @param name
 * @param platformStoreScopes
 * @returns
 */
export const createDepartment = (body: CreateDepartmentRequest) => {
  return resolve(
    storeHomeV2Client.post<ImResponse<CreateDepartmentResponse>>(`/admin/departments`, body),
  );
};

export interface UpdateDepartmentBody {
  id: StoreHomeV2.Department['id'];
  name: string;
  platformStoreScopes: General.StoreScope[];
}
/**
 * 更新部门
 * @param name
 * @param platformStoreScopes
 * @returns
 */
export const updateDepartment = (body: UpdateDepartmentBody) => {
  return resolve(
    storeHomeV2Client.put<ImResponse<CreateDepartmentResponse>>(`/admin/departments/${body.id}`, {
      name: body.name,
      platformStoreScopes: body.platformStoreScopes,
    }),
  );
};

/**
 *
 * 删除部门
 * @param departmentId
 * @returns
 */
export const deleteDepartment = (departmentId: StoreHomeV2.Department['id']) => {
  return storeHomeV2Client.delete(`/admin/departments/${departmentId}`);
};

/**
 *  从部门中移除user
 * @param departmentId
 * @param userId
 * @returns
 */
export const removeUserFromDepartment = (departmentId: number, userId: number) => {
  return resolve(
    storeHomeV2Client.delete<ImResponse<void>>(
      `/admin/departments/${departmentId}/users/${userId}`,
      {},
    ),
  );
};

/**
 * 查询部门下没有配置帐号参与咨询分配的店铺列表
 * @param departmentId
 * @returns
 */
export const getDepartmentNoReceptionStoreList = (departmentId: StoreHomeV2.Department['id']) => {
  return storeHomeV2Client.get<ImResponse<StoreHomeV2.NoReceptionStore[]>>(
    `/admin/department/${departmentId}/no_reception_stores`,
  );
};

/**
 * 部门管理 -> 部门店铺咨询分配
 * @param params
 */
export const getDepartmentStoreConsultationDistribution = (params: {
  departmentId: number;
  page: number;
  pageSize: number;
  keyword: string;
}) => {
  return resolve(
    storeHomeV2Client.get<ImResponse<StoreHomeV2.StoreConsultationDistribution>>(
      `/admin/department/assign_conversation_stores`,
      {
        params,
      },
    ),
  );
};

/**
 * 部门管理 -> 部门店铺咨询分配 -> 导出咨询分配明细
 * @param data
 */
export const exportAssignConversationStores = (data: {
  keyword: string;
  departmentId: number;
  language: string;
}) => {
  return storeHomeV2Client.post('/admin/department/export_assign_conversation_stores', data);
};

// 查询部门下智能分配角色是否所有账号都没有绑定账号
export const getIsAllRoleNoAccount = (departmentId: string) => {
  return resolve(
    storeHomeV2Client.get<ImResponse<boolean>>('/admin/department/is_all_role_no_account', {
      params: {
        departmentId,
      },
    }),
  );
};

interface DepartmentUser {
  account: string;
  phoneNumber: string;
  sleepFlag: boolean;
  userId: number;
  userStatus: 'ENABLE' | 'DISABLE';
  userType: number;
}

/**
 * 查询部门下用户
 * @param departmentIds 部门ID列表, 如果不传则查询所有部门下用户
 * @returns
 */
export const getDepartmentUsers = (departmentIds?: string[], signal?: AbortSignal) => {
  return resolve(
    storeHomeV2Client.get<ImResponse<DepartmentUser[]>>(`/admin/departments/user`, {
      params: {
        departmentIds,
      },
      signal,
    }),
  );
};
